import {InjectionToken} from '@angular/core';

import {Environment} from '../environments';

export const ENV_TOKEN = new InjectionToken<Environment<unknown>>('ENV_TOKEN');
